import { eventListener } from './event';

export function focusOutside(target, fn) {
  const event = eventListener(target, 'focusout', listener);

  function listener(event) {
    if (
      !event.relatedTarget
      || target.contains(event.relatedTarget)
    ) return;

    fn(event);
  }

  return event;
}
